var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowUpRightIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8334 2.5C14.8334 2.22386 14.6095 2 14.3334 2H8.33337C8.05723 2 7.83337 2.22386 7.83337 2.5C7.83337 2.77614 8.05723 3 8.33337 3H13.1263L2.97982 13.1464C2.78456 13.3417 2.78456 13.6583 2.97982 13.8536C3.17508 14.0488 3.49166 14.0488 3.68693 13.8536L13.8334 3.70711V8.5C13.8334 8.77614 14.0572 9 14.3334 9C14.6095 9 14.8334 8.77614 14.8334 8.5V2.5Z",
    fill: "#314F61"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRightIcon);
export default __webpack_public_path__ + "static/media/arrow-up-right-icon.6ba8bb0630401ef4871d45343ee3e207.svg";
export { ForwardRef as ReactComponent };